import type { ChatView } from '#contract'
import { useT } from '../../../i18n/index.ts'
import { appById } from '../index.ts'
import styles from './wassup.module.css'

/** A chat's picture: an official account's app icon, else the name's initial on a disc. */
export function Avatar({
  chat,
  small = false,
}: {
  readonly chat: ChatView
  readonly small?: boolean
}) {
  const t = useT()
  const size = small ? styles.avatarSmall : styles.avatar
  if (chat.app !== null) {
    const Icon = appById(chat.app).icon
    return <Icon class={size} />
  }
  return (
    <span class={[size, styles.initial].join(' ')} aria-hidden="true">
      {t(chat.name).slice(0, 1).toUpperCase()}
    </span>
  )
}
